import React, { useEffect, useState } from "react";
import RadioYesComponent from "./RadioYesComponent";
import { fetchUandetails, saveUanEmployment } from "../../Actions/uanActions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const RadioNoButtons = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState(null);
  const [reason, setReason] = useState("");
  const [showAdditionalInput, setShowAdditionalInput] = useState(false);
  const [showAddEmploymentFlow, setShowAddEmploymentFlow] = useState(false);
  const [showCandidateHistory, setShowCandidateHistory] = useState(false);
  const [isCompleted,setIsCompleted] = useState(false);

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  useEffect(() => {
    if(props?.noReason && props?.noReason != '' && !props?.manualChange){
      // if(props?.noReason == 'Other'){
      //   setShowAdditionalInput(true);
      //   setReason(props?.noReason);
      // }
      let arr = props?.noReason.split('-');
      if(arr[0] == 'Other'){
        setShowAdditionalInput(true);
        setReason(arr[1]);
        setSelectedOption(arr[0]);
      }else{
        setSelectedOption(props?.noReason);
      }
      if(props.noReason != 'I am Fresher'){
        handleFetchEmployment();
      }
    }
  },[props]);

  useEffect(() => {
    if(props?.checkCompleted && props?.checkCompleted == true){
      if(props.noReason != 'I am Fresher'){
        handleFetchEmployment();
      }
      setIsCompleted(true);
    }
  },[props?.checkCompleted]);

  const handleOptionChange = (option) => {
    setSelectedOption(option);
    setShowAdditionalInput(option === "Other");
    setShowAddEmploymentFlow(option !== "I am Fresher");
    setShowCandidateHistory(false);
    setReason('');
  };

  const handleReasonChange = (event) => {
    setReason(event.target.value);
  };


  const handleBackClick = () => {
    // Add logic for back button click if needed
  };

  const handleContinueClick = () => {
    console.log(props)
    let record={}
    record.case_check_id = props?.formData?.checksDetails[0]?.case_check_id;
    let resp = selectedOption != 'Other' ? selectedOption : `${selectedOption}-${reason}`

    const obj = {
      group: "employment_via_uan",
      // "13": "12\/2014",
      // "69": "3",
      // "11": "3333",
      // "12": "",
      // "138": "test",
      // "52": "1",
      "493": "No",
      "494": resp
    };

    record.check_data = { [props?.formData?.checksDetails[0]?.case_check_id]: obj };

    console.log(record)

    dispatch(saveUanEmployment(record, callbackRedirect))

    
    // if(showAddEmploymentFlow){
    //   setShowCandidateHistory(true);
    // }
  };

  const callbackRedirect=(data)=>{
  
    if(data?.empUanCallManual==0)
    {
    if (data?.reference_number) {
      const referenceNumber = data?.reference_number;
      const groupID = data?.group?.group_id;
      if (groupID && groupID === "profile_preview") {
        navigate(`/case-initiation/profile-preview/${referenceNumber}`);
      } else {
        navigate(`/case-initiation/check-detail/${referenceNumber}/${groupID}`);
      }
    }
  }
  if(data?.empUanCallManual==1){
    handleFetchEmployment();
  }

}

const handleFetchEmployment = () => {
  // You can perform an API call or any other logic here to fetch employment details
  // For demonstration, let's assume an employment gap of 2 years and 8 months
  // const formData = props?.formData
  // console.log(formData)
  // dispatch(fetchUandetails(formData?.candidate_id,formData?.candidates?.initial_case_id, formData?.checksDetails[0]?.case_check_id));
  // setShowEmploymentDetails(true);
  // setButtonText("Verify");
  setShowCandidateHistory(true); 
};

const handleSubmitForPreview = (e) => {
  e.preventDefault();
  const currentUrl = window.location.href;
  const [partA, partB] = currentUrl.split("/check-detail/");
  const [reference, route] = partB.split("/");
  navigate(`/case-initiation/profile-preview/${reference}`);
};

  return (
    <>
      {<div className="pl-4">
        <p className="col-12 p-0 ml-n4">Please select the appropriate reason <sup className="text-danger">{''}*</sup></p>
        <div className="form-check px-1 py-2">
          <input
            type="radio"
            className="form-check-input"
            id="fresher"
            name="employmentStatus"
            checked={selectedOption === "I am Fresher"}
            onChange={() => handleOptionChange("I am Fresher")}
            disabled={isCompleted}
          />
          <label
            className="form-check-label pl-2"
            style={{ paddingTop: "3px" }}
            htmlFor="fresher"
          >
            I am Fresher
          </label>
        </div>

        <div className="form-check px-1 py-2">
          <input
            type="radio"
            className="form-check-input"
            id="noUAN"
            name="employmentStatus"
            checked={selectedOption === "Previour employer did not provided UAN Number"}
            onChange={() => handleOptionChange("Previour employer did not provided UAN Number")}
            disabled={isCompleted}
          />
          <label
            className="form-check-label pl-2"
            style={{ paddingTop: "3px" }}
            htmlFor="noUAN"
          >
            Previous employer didn’t provide UAN number
          </label>
        </div>

        <div className="form-check px-1 py-2">
          <input
            type="radio"
            className="form-check-input"
            id="uanNotCreated"
            name="employmentStatus"
            checked={selectedOption === "UAN number not created yet"}
            onChange={() => handleOptionChange("UAN number not created yet")}
            disabled={isCompleted}
          />
          <label
            className="form-check-label pl-2"
            style={{ paddingTop: "3px" }}
            htmlFor="uanNotCreated"
          >
            UAN number not created yet
          </label>
        </div>

        <div className="form-check px-1 py-2">
          <input
            type="radio"
            className="form-check-input"
            id="other"
            name="employmentStatus"
            checked={selectedOption === "Other"}
            onChange={() => handleOptionChange("Other")}
            disabled={isCompleted}
          />
          <label
            className="form-check-label pl-2"
            style={{ paddingTop: "3px" }}
            htmlFor="other"
          >
            Other
          </label>

          {showAdditionalInput && (
            <div className="row w-100 p-2">
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label>
                  <span className="text-danger text-sm">*</span>Add reason:
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter reason here"
                  value={reason}
                  onChange={handleReasonChange}
                  required
                />
              </div>
            </div>
          )}
          {/* {showAddEmployment&&<AddNewEmploymentDetailBlock setShowAddEmployment={setShowAddEmployment}/>}
              {showAddEmploymentButton&&<button className="btn btnAddEmp" onClick={handleAddEmploymentButton}>
                + Add Employment
              </button>} */}
        </div>
        

        {((selectedOption !== null && selectedOption != 'Other') || (selectedOption == 'Other' && reason != '')) && (
          <div className="row w-100">
          {showCandidateHistory == false && 
            <div className="col-lg-2 col-md-6 com-sm-10 d-flex justify-content-between align-items-center my-4">
              {/* <div
                className="btn btn-lg btn-outline-secondary"
                onClick={handleBackClick}
              >
                Back
              </div> */}
             <div
                className="btn btn-lg btn-primary cursor-pointer"
                onClick={handleContinueClick}
              >
                Continue
              </div>
            </div>
              } 
          </div>
        )}
      {props?.showProfilePreview == 1 && (
                  <div className="row">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block"
                        onClick={(e) => handleSubmitForPreview(e)}
                      >
                        {clientId == 459831 ? "Preview" : "Submit for Preview"}
                      </button>
                    </div>
                   </div>
                )}
      </div>}
      {showCandidateHistory !=false && 
      <RadioYesComponent flow="No" 
      formData={props?.formData} selectedOption={selectedOption} gapObject={props?.gapObject} reason={reason}
      />
      }
    </>
  );
};

export default RadioNoButtons;
